(() => {
                const refs = {
                    openModalBtn: document.querySelector("[data-map-modal-open]"),
                    closeModalBtn: document.querySelector("[data-map-modal-close]"),
                    modal: document.querySelector("[data-map-modal]"),
                };

                refs.openModalBtn.addEventListener("click", toggleModal);
                refs.closeModalBtn.addEventListener("click", toggleModal);

                function toggleModal() {
                    refs.modal.classList.toggle("is-hidden");
                }
})();

(() => {
                const refs = {
                    openModalBtn: document.querySelector("[data-map2-modal-open]"),
                    closeModalBtn: document.querySelector("[data-map2-modal-close]"),
                    modal: document.querySelector("[data-map2-modal]"),
                };

                refs.openModalBtn.addEventListener("click", toggleModal);
                refs.closeModalBtn.addEventListener("click", toggleModal);

                function toggleModal() {
                    refs.modal.classList.toggle("is-hidden");
                }
})();